var BuyBoxType;
(function (BuyBoxType) {
    BuyBoxType["AboveTheFold"] = "AboveTheFold";
    BuyBoxType["BuyBoxBottomSheetShort"] = "BuyBoxBottomSheetShort";
    BuyBoxType["BuyBoxBottomSheetExpanded"] = "BuyBoxBottomSheetExpanded";
    BuyBoxType["BuyBoxBottomSheetAlwaysExpanded"] = "BuyBoxBottomSheetAlwaysExpanded";
    BuyBoxType["BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop"] = "BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop";
})(BuyBoxType || (BuyBoxType = {}));

export { BuyBoxType };
//# sourceMappingURL=BuyBoxType.js.map
